import { createSelector } from '@reduxjs/toolkit'

import { FORM_STEPS } from '@/constants/checkout'
import {
  isPerpetualPackageSelector,
} from '@/selectors'

import { SEARCHABLE_ROLE } from './helpers'

export const isUserStudentSelector = createSelector(
  [
    state => state.user.searchableRole.name
  ],
  name => name === SEARCHABLE_ROLE.student
)

export const userInstitutionNameSelector = createSelector(
  [
    state => state.user.institution.name,
    state => state.institutions.institution.name
  ],
  (currentInstitution, selectedInstitution) => (
    selectedInstitution || currentInstitution
  )
)

export const isEditingInstitutionSelector = createSelector(
  [
    state => state.checkout.activeStep,
    state => state.user.institution.name,
    state => state.institutions.institution.name
  ],
  (activeStep, currentInstitution, selectedInstitution) => (
    activeStep === FORM_STEPS.institutionPickerEdit
    || (currentInstitution === null && selectedInstitution === null)
  )
)

export const showExpirationSelector = createSelector(
  [
    isPerpetualPackageSelector,
    state => state.asset.isSubscription
  ],
  (isPerpetualPackage, isSubscription) => (
    !isPerpetualPackage && !isSubscription
  )
)
